var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"account-profile-tab"}},[_c('card-widget',{scopedSlots:_vm._u([{key:"cardBody",fn:function(){return [_c('add-account-form',{attrs:{"show-form":""},on:{"set-account":_vm.setAccount}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }